import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import './Frames.css';

const API_BASE = 'https://api.laviopaperie.com';

const SHAPE_COLORS = [
  '#8EB080', // 1
  '#F2B785', // 2
  '#FF5252', // 3
  '#B4E0DD', // 4
  '#CEB4E0', // 5
  '#FCF99F', // 6
  '#3A3A4F', // 7
  '#992955', // 8
];

function getShapeColor(indexZeroBased) {
  const i = indexZeroBased;
  if (i < SHAPE_COLORS.length) return SHAPE_COLORS[i];
  return '#696969';
}

const Frames = () => {
  const [list, setList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [selectedFrameId, setSelectedFrameId] = useState(null);
  const [selectedSessionId, setSelectedSessionId] = useState(null);

  // Untuk tinggi preview container kanan
  const previewRef = useRef();
  const [previewHeight, setPreviewHeight] = useState(480);

  useEffect(() => {
    function updateHeight() {
      if (previewRef.current) {
        setPreviewHeight(previewRef.current.offsetHeight || 480);
      }
    }
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  // Load categories once
  useEffect(() => {
    const loadCats = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/workspaces?limit=100`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Gagal memuat kategori');
        const uniq = Array.from(new Set((data.workspaces || []).map(w => (w.category || '').trim()).filter(Boolean)));
        setCategories(['All', ...uniq]);
      } catch (e) {
        setCategories(['All']);
      }
    };
    loadCats();
  }, []);

  // Nonaktifkan scroll Y pada seluruh halaman saat berada di page Frames
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const prevOverflow = document.body.style.overflow;
    const prevHeight = document.body.style.height;
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.height = prevHeight;
    };
  }, []);

  // Load frames by selected category
  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const param = (selectedCategory && selectedCategory !== 'All') ? `&category=${encodeURIComponent(selectedCategory)}` : '';
        const res = await fetch(`${API_BASE}/api/workspaces?limit=100${param}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Gagal memuat daftar frame');
        setList(data.workspaces || []);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [selectedCategory]);

  const selectFrame = async (id) => {
    // Generate session ID untuk frame ini
    const sessionId = `session_${Date.now()}`;

    // Simpan frame terpilih per session di localStorage
    const sessionFrames = JSON.parse(localStorage.getItem('sessionFrames') || '{}');
    sessionFrames[sessionId] = id;
    localStorage.setItem('sessionFrames', JSON.stringify(sessionFrames));

    // Simpan session ID untuk digunakan di camera session
    localStorage.setItem('currentSessionId', sessionId);

    // Set selected state (tanpa alert, tanpa langsung navigate)
    setSelectedFrameId(id);
    setSelectedSessionId(sessionId);
  };

  if (loading) return <div className="frames-page"><p>Memuat daftar frame...</p></div>;
  if (error) return <div className="frames-page"><p style={{color:'#dc3545'}}>{error}</p></div>;

  return (
    <div className="frames-page" style={{ padding: 0, margin: 0, minHeight: '100vh', height: '100vh', width: '100vw', background: 'linear-gradient(135deg, #dac9f7 0%, #dac9f7 100%)', overflow: 'hidden', zoom: '100%' }}>
      <div style={{ display: 'flex', height: '100%', width: '100%', overflow: 'hidden' }}>
        {/* eft: list frame scrollable */}
        <div style={{ width: 700, minWidth: 0, height: '100vh', maxHeight: '100vh', overflowY: 'auto', background: 'rgba(255,255,255,0.85)', borderRight: '2px solid #E9D4FC', boxShadow: '4px 0 20px #CBB1E033', display:'flex', flexDirection: 'column', alignItems: 'stretch', position:'relative' }}>

          {/* Category slider */}
          <div style={{
            display: 'flex',
            gap: 8,
            overflowX: 'auto',
            padding: '12px 2px 14px 2px',
            marginBottom: 0,
            background:'#f4eefb',
            position:'sticky',
            top:0, zIndex:3,
            boxShadow:'0 3px 14px #e5daf277'
          }}>
            {categories.map((cat) => {
              const active = cat === selectedCategory;
              return (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  style={{
                    whiteSpace: 'nowrap',
                    padding: '8px 14px',
                    borderRadius: 999,
                    border: active ? '1.5px solid #ccb4d6' : '1px solid #e9ecef',
                    background: active ? '#E9D4FC' : '#ffffff',
                    color: active ? '#3b2f46' : '#533b62',
                    fontWeight: 600,
                    fontSize: '18px',
                    boxShadow: active ? '0 6px 16px rgba(204,180,214,0.2)' : 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {cat}
                </button>
              );
            })}
          </div>

          <div style={{ flex:1, overflowY:'auto', marginTop:6, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, 300px)', columnGap: 18, rowGap: 50, paddingBottom:16, justifyContent:'center' }}>
            {list.map((w) => {
              const isSelected = selectedFrameId === w.id;
              return (
                <div
                  key={w.id}
                  onClick={() => selectFrame(w.id)}
                  style={{
                    width: '300px',
                    height: '300px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: isSelected ? '3px solid #FF9CA7' : '1px solid #e9ecef',
                    borderRadius: 10,
                    background:'#fff',
                    padding: 7,
                    marginBottom: 2,
                    cursor:'pointer',
                    boxShadow: isSelected ? '0 6px 14px #eec3e855' : '0 1.5px 5px #cbb1e028',
                    transform: isSelected ? 'scale(1.075)' : 'scale(1.00)',
                    transition: 'all 0.18s',
                    position:'relative',
                    zoom: '100%'
                  }}
                >
                  <FramePreview
                    workspaceId={w.id}
                    backgroundPath={w.background_path}
                    canvasWidth={w.canvas_width}
                    canvasHeight={w.canvas_height}
                    small
                  />
                </div>
              )
            })}
          </div>
        </div>
        {/* Right: besar untuk frame selected */}
        <div ref={previewRef} style={{ flex: 1, minWidth: 0, display:'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', position:'relative', height: '100%' }}>
          {selectedFrameId ? (
            <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign:'center', background:'#fff8', borderRadius: 16, boxShadow: '0 8px 48px #daaadc23', gap: 18, position:'relative' }}>
              <FramePreview
                workspaceId={selectedFrameId}
                backgroundPath={(list.find(f => f.id === selectedFrameId) || {}).background_path}
                canvasWidth={(list.find(f => f.id === selectedFrameId) || {}).canvas_width}
                canvasHeight={(list.find(f => f.id === selectedFrameId) || {}).canvas_height}
                boxHeight={previewHeight}
              />
              <button
                onClick={() => navigate('/camera-session')}
                style={{
                  position: 'absolute',
                  top: 18,
                  right: 26,
                  padding: '12px 26px',
                  background: 'linear-gradient(90deg, #654c65 0%, #654c65 100%)',
                  color: 'white',
                  border: '2px solid #e0c5eb',
                  borderRadius: 14,
                  boxShadow: '0 4px 18px #eec3e846',
                  fontWeight: 700,
                  cursor: 'pointer',
                  fontSize: '1.1rem',
                  transition:'all .18s',
                }}
              >
                Start ➜
              </button>
            </div>
          ) : (
            <div style={{color:'#cdc', fontWeight: 500, fontSize: 22}}>Choose ur frame</div>
          )}
        </div>
      </div>
    </div>
  );
};

// Component untuk preview frame dengan background + assets + grid
const FramePreview = ({ workspaceId, backgroundPath, canvasWidth, canvasHeight, small, boxHeight }) => {
  const [workspace, setWorkspace] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    const loadWorkspaceDetails = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/api/workspaces/${workspaceId}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Gagal memuat detail workspace');
        if (!mounted) return;
        setWorkspace(data.workspace);
        setItems(data.items || []);
      } catch (e) {
        console.warn(`Failed to load workspace ${workspaceId}:`, e.message);
        // Fallback ke data minimal jika gagal load detail
      } finally {
        if (mounted) setLoading(false);
      }
    };
    loadWorkspaceDetails();
    return () => { mounted = false; };
  }, [workspaceId]);

  // Jika small, selalu 250.
  // Jika bukan small, gunakan tinggi viewport agar preview kanan jauh lebih besar,
  // terutama di layar dengan resolusi besar.
  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800;
  const boxHeightFinal = small
    ? 250
    : Math.max(480, Math.round(viewportHeight * 0.75));
  const cw = Math.max(1, (workspace?.canvas_width) || canvasWidth || 1000);
  const ch = Math.max(1, (workspace?.canvas_height) || canvasHeight || 700);
  const scale = boxHeightFinal / ch;

  return (
    <div style={{ 
      width: '100%', 
      height: boxHeightFinal, 
      position: 'relative', 
      overflow: 'hidden',
      // background: '#f8f9fa', 
      background: 'transparent',
      border: '1px dashed #dee2e6', 
      borderRadius: 6 
    }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: cw,
        height: ch,
        transform: `translate(-50%, -50%) scale(${scale})`,
        transformOrigin: 'center center',
      }}>
        {/* Background */}
        {backgroundPath && (
          <img
            src={`${API_BASE}${backgroundPath}`}
            alt="background"
            style={{ 
              position: 'absolute', 
              top: 0, 
              left: '50%', 
              transform: 'translateX(-50%)', 
              height: '100%', 
              width: 'auto', 
              objectFit: 'contain' 
            }}
          />
        )}

        {/* Back layer assets */}
        {items.filter(item => item.item_type === 'asset' && (item.layer === 'back' || !item.layer)).map(asset => (
          <div key={`asset-back-${asset.id}`} style={{
            position: 'absolute',
            left: asset.x,
            top: asset.y,
            width: asset.width,
            height: asset.height,
            transform: `rotate(${asset.rotation_deg || 0}deg)`,
            transformOrigin: 'center center',
            overflow: 'hidden',
            zIndex: 2
          }}>
            {asset.src_path && (
              <img 
                src={`${API_BASE}${asset.src_path}`} 
                alt="asset" 
                style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
              />
            )}
          </div>
        ))}

                 {/* Grid slots (shapes) */}
         {items.filter(item => item.item_type === 'shape').map((shape, index) => {
           const slotNumber = index + 1;
           const slotColor = getShapeColor(slotNumber - 1);
           return (
             <div key={`shape-${shape.id}`} style={{
               position: 'absolute',
               left: shape.x,
               top: shape.y,
               width: shape.width,
               height: shape.height,
               transform: `rotate(${shape.rotation_deg || 0}deg)`,
               transformOrigin: 'center center',
               overflow: 'hidden',
               borderRadius: shape.border_radius || 0,
               zIndex: 3,
               background: shape.background_color || slotColor,
               border: `2px solid ${shape.border_color || slotColor}`,
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               color: shape.text_color || '#ffffff',
               fontSize: 12,
               fontWeight: 'bold',
               textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
             }}>
               {slotNumber}
             </div>
           );
         })}

        {/* Front layer assets */}
        {items.filter(item => item.item_type === 'asset' && item.layer === 'front').map(asset => (
          <div key={`asset-front-${asset.id}`} style={{
            position: 'absolute',
            left: asset.x,
            top: asset.y,
            width: asset.width,
            height: asset.height,
            transform: `rotate(${asset.rotation_deg || 0}deg)`,
            transformOrigin: 'center center',
            overflow: 'hidden',
            zIndex: 4
          }}>
            {asset.src_path && (
              <img 
                src={`${API_BASE}${asset.src_path}`} 
                alt="asset" 
                style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
              />
            )}
          </div>
        ))}
      </div>

      {/* Loading indicator */}
      {loading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'rgba(0,0,0,0.7)',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '10px',
          zIndex: 10
        }}>
          Loading...
        </div>
      )}
    </div>
  );
};

export default Frames;
